module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Cabo-Roche-856e104988f00da255efad0d0cd0113f.jpg";